import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
    selector: 'app-return-remove-drawer',
    templateUrl: './return-remove-drawer.component.html',
    standalone: false
})
export class ReturnRemoveDrawerComponent {
  public returnRemoveForm!: FormGroup;
  public selectedPackages: any[] = [];

  @Output() submitAction: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('returnRemoveDrawer', { static: true }) drawer!: MatSidenav;

  showRouteCodeInput: boolean = false; // Visibility of Route Code input

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.createForm();
  }

  private createForm() {
    this.returnRemoveForm = this.formBuilder.group({
      actionType: ['return', [Validators.required]],
      packageComment: ['', Validators.required],
      routeCode: [''],
    });
  }

  // Toggle drawer visibility
  public toggleReturnRemove() {
    if (this.drawer) {
      // Reset each time the drawer is open/closed
      this.returnRemoveForm.reset({
        actionType: 'return',
      });
      this.drawer.toggle();
    }
  }

  // Open the drawer with courier check passed
  public openWithCourierCheck(hasDHL: boolean, selectedPackages: any[]) {
    this.showRouteCodeInput = hasDHL;
    this.selectedPackages = selectedPackages;
    // Reset when opening drawer for a new action
    this.returnRemoveForm.reset({
      actionType: 'return',
    });
    if (hasDHL) {
      // Set route code if DHL
      this.returnRemoveForm.get('routeCode')?.setValidators([Validators.required]);
    } else {
      // If not DHL, clear validators
      this.returnRemoveForm.get('routeCode')?.clearValidators();
    }
    this.returnRemoveForm.get('routeCode')?.updateValueAndValidity();
    this.drawer.open();
  }

  // Submit form data
  public onSubmitAction() {
    const formData = this.returnRemoveForm.value;
    this.submitAction.emit({ formData, selectedPackages: this.selectedPackages });
    this.drawer.toggle();
  }
}
